import Typography from '@/common/components/base/typography/Typography';
import { ImageSliderPropsType } from '@/common/components/camera/types/components.type';

import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const AroundSlider = ({
  sliderData,
  turn,
}: {
  sliderData: ImageSliderPropsType['sliderData']['vehicle'];
  turn: ImageSliderPropsType['turn'];
}) => {
  const calculatePixelTranslation = (indexItem: number) => {
    const width = 105;
    let pixel = (indexItem - 1) * width;

    if (pixel > (sliderData?.length! - 5) * width) {
      pixel = (sliderData?.length! - 4) * width;
    }
    return `translateX(${pixel}px)`;
  };
  return (
    <Box
      className={css({
        position: 'fixed',
        top: '35px',
        right: '10px',
        width: '100vw',
        maxWidth: 'maxContainer',
        transition: 'all 0.7s ease-out',
        height: '9rem',
      })}
      style={{
        transform: calculatePixelTranslation(turn),
      }}
    >
      <Box className={css({ display: 'flex' })}>
        {sliderData?.flatMap((slide, index) => {
          const currentCapturing = index === turn;

          return slide.image ? (
            <Box
              key={`${slide.id}`}
              className={css({ display: 'flex', flexDirection: 'column' })}
            >
              <Box
                key={slide.id}
                backgroundColor="white"
                className={css({
                  p: '5px',
                  height: '75px',
                  width: '105px',
                  rotate: '90deg',
                  border: currentCapturing ? '2px solid ' : '0px',
                  borderColor: 'purple-primary',
                  borderRadius: '8px',
                })}
              >
                <img
                  className={css({
                    width: '100%',
                    height: '100%',
                  })}
                  src={slide.image}
                  alt={slide.fa_name}
                />
              </Box>
              <Typography
                textStyle="b2"
                color={currentCapturing ? 'white' : 'initial'}
                className={css({
                  zIndex: '1',
                  textAlign: 'center',
                  backgroundColor: currentCapturing
                    ? 'purple-primary'
                    : 'white',
                  width: '100px',
                  borderRadius: '8px',
                })}
              >
                {slide.fa_name}
              </Typography>
            </Box>
          ) : (
            []
          );
        })}
      </Box>
    </Box>
  );
};

export default AroundSlider;
